<template>
  <page-wrapper ref="pageEl" title="Transaction History">
    <div class="page-container row">
      <!-- Router -->
      <div class="router">
        <span
          style="color: #b5b5b5"
          @click="handleBackToWalletBalanceReportPage"
        >
          Wallet Balance /
        </span>
        <span
          v-if="hasWalletDetail"
          style="color: #409eff; text-decoration: underline"
        >
          {{ walletDetail.wallet_name }}
        </span>
      </div>

      <div v-if="hasWalletDetail" class="detail mb-3">
        <h5 style="font-weight: 600">
          {{ walletDetail.wallet_name }}
        </h5>
        <!-- Detail -->
        <div class="section mt-3">
          <div>
            <p class="title">User ID</p>
            <p class="title">Created Date</p>
            <p class="title">Project Code</p>
            <p class="title">Address No.</p>
            <p class="title">Status</p>
          </div>
          <div class="ms-3">
            <p class="value">{{ userId }}</p>
            <p class="value">{{ walletDetail.created_at }}</p>
            <p class="value">{{ walletDetail.project_code }}</p>
            <p class="value">{{ walletDetail.address_number }}</p>
            <p class="value">{{ walletDetail.status }}</p>
          </div>
          <div class="ms-5">
            <p class="title">Name</p>
            <p class="title">Mobile No.</p>
            <p class="title">Email</p>
            <p class="title">Role</p>
            <p class="title">Employee ID</p>
          </div>
          <div class="ms-3">
            <p class="value">{{ walletDetail.full_name }}</p>
            <p class="value">{{ walletDetail.mobile_number }}</p>
            <p class="value">{{ walletDetail.email }}</p>
            <p class="value">{{ walletDetail.role }}</p>
            <p class="value">{{ walletDetail.employee_id }}</p>
          </div>
        </div>

        <!-- Balance -->
        <div class="balance mt-4">
          <div class="section">
            <div class="left">
              <div>Balance {{ getCurrentYear() - 1 }}</div>
              <div>Balance {{ getCurrentYear() }}</div>
            </div>
            <div class="right">
              <div>{{ walletDetail.last_year_balance }}</div>
              <div>{{ walletDetail.current_year_balance }}</div>
            </div>
          </div>
          <div class="vertical-divider"></div>
          <div class="section">
            <div class="left">Total</div>
            <h2
              class="right"
              style="color: #409eff; line-height: 0.5; align-self: flex-end"
            >
              {{ walletDetail.total_balance }}
            </h2>
          </div>
        </div>
      </div>

      <!-- Divider -->
      <el-divider />

      <!-- Filter -->
      <div class="filter col-12 mt-2">
        <div class="form">
          <!-- Date Picker -->
          <div class="section">
            <div>
              <div class="label">Created Date</div>
              <date-picker
                v-model="selectedCreatedDateRange"
                :disabled="isDropdownDisabled"
                type="daterange"
              >
              </date-picker>
            </div>
          </div>

          <!-- Dropdown -->
          <div class="section">
            <div>
              <div class="label">Transaction Status</div>
              <el-select
                v-model="selectedTransactionStatus"
                :disabled="isDropdownDisabled"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="status in filterTransactionStatusOptions"
                  :key="status.value"
                  :label="status.label"
                  :value="status.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="label">Transaction Type</div>
              <el-select
                v-model="selectedTransactionType"
                :disabled="isDropdownDisabled"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="type in filterTransactionTypeOptions"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <div class="label">MNC Type</div>
              <el-select
                v-model="selectedMorningCoin"
                :disabled="isDropdownDisabled"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="mnc in filterMorningCoins"
                  :key="mnc.coin_id"
                  :label="mnc.coin_name"
                  :value="mnc.coin_id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- Button -->
          <div class="mt-2" style="display: flex; justify-content: center">
            <el-button
              :disabled="isSearchDisabled"
              type="primary"
              @click="handleSearch"
            >
              ค้นหา
            </el-button>
            <el-button
              :disabled="isClickDownloadAsCSVDisabled"
              type="info"
              @click.prevent="downloadReportFile"
            >
              ดาวน์โหลด
            </el-button>
            <el-button
              :disabled="isClearDisabled"
              plain
              type="danger"
              @click="handleClickClear"
            >
              รีเซ็ต
            </el-button>
          </div>

          <!-- Report List -->
          <div class="content col-12 mt-2">
            <div>
              <!-- Header -->
              <div v-show="latestUpdateMessage != null" class="header">
                <div>
                  <b>รายงานอัปเดต</b>
                  <p>{{ latestUpdateMessage }}</p>
                </div>
                <div>
                  <div>
                    <p>{{ totalCount }}</p>
                  </div>
                  <div align="right">
                    <el-button
                      v-for="index in [10, 20, 30]"
                      :key="index"
                      :type="limit == index ? 'primary' : ''"
                      circle
                      size="small"
                      @click="limit = index"
                    >
                      {{ index }}
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- List -->
              <div class="mt-3">
                <DataTable
                  :data="reports"
                  :headers="headers"
                  :loading="tableLoading"
                >
                </DataTable>
              </div>

              <!-- Pagination -->
              <div class="mt-3" style="text-align: center">
                <el-pagination
                  :total="total"
                  :disabled="isPaginationDisable"
                  :current-page="page"
                  :page-size="limit"
                  background
                  layout="prev, pager, next"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
// Dependencies
import { DateTime } from "luxon"
import { backendAdminClient } from "@/dependencies"
import { formatOrFallbackToInput } from "@/lib/dateTime"

// Components
import PageWrapper from "@/lib/components/PageWrapper"
import DatePicker from "@/lib/components/DatePicker"
import DataTable from "@/lib/components/DataTable"

export default {
  components: {
    PageWrapper,
    DatePicker,
    DataTable,
  },

  data() {
    // NOTE: Destructure route params
    const { filterMorningCoins } = this.$route.params
    const walletDetail = this.$route.params.data || undefined

    const filterTransactionStatusOptions = [
      { value: "BURNED" },
      { value: "REFUNDED" },
      { value: "EARNED" },
      { value: "SUCCESS" },
    ]

    const filterTransactionTypeOptions = [
      { value: "BURN" },
      { value: "EARN" },
      { value: "TRANSFER" },
      { value: "REFUND" },
      { value: "CLAIM" },
      { value: "ROLLBACK_REFUND" },
      { value: "ROLLBACK" },
      { value: "EXPIRED" },
      { value: "TRANSACTION_REVERSAL" },
    ]

    const filterInput = {
      filterTransactionStatusOptions,
      filterTransactionTypeOptions,
      filterMorningCoins,
    }

    const selectInputFilter = {
      selectedCreatedDateRange: undefined,
      selectedTransactionStatus: undefined,
      selectedTransactionType: undefined,
      selectedMorningCoin: undefined,
    }

    const isDisabledInput = {
      isDropdownDisabled: false,
      isSearchDisabled: false,
      isClickDownloadAsCSVDisabled: false,
      isClearDisabled: false,
      isPaginationDisable: false,
    }

    const pagination = {
      page: 1,
      limit: 10,
      total: 0,
      latest_update_time: "",
    }

    const headers = [
      {
        label: "Transaction Name",
        value: "transaction_name",
      },
      {
        label: "From",
        value: "from_wallet_name",
      },
      {
        label: "To",
        value: "to_wallet_name",
      },
      {
        label: "MNC Type",
        value: "year_balance",
      },
      {
        label: "Amount",
        value: "coin",
      },
      {
        label: "Created Date",
        value: "created_at",
      },
      {
        label: "Created By",
        value: "created_by",
      },
      {
        label: "Status",
        value: "status",
      },
    ]

    return {
      ...filterInput,
      ...selectInputFilter,
      ...isDisabledInput,
      ...pagination,
      walletDetail,
      tableLoading: false,
      reports: [],
      headers,
    }
  },
  computed: {
    userId() {
      return this.$route.params.userId
    },
    hasWalletDetail() {
      return this.walletDetail !== undefined
    },
    hasFilterMorningCoins() {
      return this.filterMorningCoins && this.filterMorningCoins.length > 0
    },
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล"
      }
      const { limit } = this
      const total = this.total.toLocaleString()
      const currentTotalItem = this.reports.length

      const isLastPage = limit > currentTotalItem
      const currentPage = +this.page || 1
      const end = (isLastPage ? total : currentPage * limit).toLocaleString()
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()
      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
    latestUpdateMessage() {
      const format = "dd MMMM yyyy เวลา HH:mm น."
      return this.formatDateToTH(this.latest_update_time, format)
    },
    queryParams() {
      const {
        page,
        limit,
        selectedTransactionStatus,
        selectedTransactionType,
        selectedMorningCoin,
        selectedCreatedDateRange,
      } = this.$route.query

      return {
        page: (page && +page) || 1,
        limit: +limit || this.limit,
        created_at_range: selectedCreatedDateRange,
        status: selectedTransactionStatus,
        type: selectedTransactionType,
        coin_id: selectedMorningCoin,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.queryBuilder()
      await this.fetchReports()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
    async limit(from, to) {
      if (from !== to) {
        await this.handleSearch()
      }
    },
  },
  created() {
    this.setupData()
  },
  methods: {
    setupData() {
      this.queryBuilder()

      // NOTE: Fetch balance detail
      if (!this.hasWalletDetail) {
        this.fetchUserBalanceByUserId(this.userId)
      }

      // NOTE: Fetch morning coins
      if (!this.hasFilterMorningCoins) {
        this.fetchCoins()
      }

      this.fetchReports()
    },
    queryBuilder() {
      const {
        page,
        limit,
        selectedTransactionStatus,
        selectedTransactionType,
        selectedMorningCoin,
        selectedCreatedDateRange,
      } = this.$route.query

      this.page = (page && +page) || 1
      this.limit = +limit || this.limit
      this.selectedTransactionStatus = selectedTransactionStatus || undefined
      this.selectedTransactionType = selectedTransactionType || undefined
      this.selectedMorningCoin = selectedMorningCoin || undefined
      this.selectedCreatedDateRange = selectedCreatedDateRange
        ? this.setupQueryDateRange(selectedCreatedDateRange)
        : undefined
    },
    handleSearch() {
      const {
        limit,
        selectedTransactionStatus,
        selectedTransactionType,
        selectedMorningCoin,
        selectedCreatedDateRange,
      } = this

      let query = {
        page: 1,
        limit,
        selectedTransactionStatus,
        selectedTransactionType,
        selectedMorningCoin,
        selectedCreatedDateRange: this.convertDateRange(
          selectedCreatedDateRange,
        ),
      }

      // NOTE: filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(([, value]) => value !== null),
      )

      // NOTE: replace route with query string
      const route = {
        name: this.$route.name,
        query,
      }
      this.$router.replace(route)
    },
    handleClickClear() {
      this.clearAllData()

      const route = {
        name: this.$route.name,
      }
      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: (page && +page) || 1 },
      }
      this.$router.replace(route)
    },
    setupQueryDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        const [from, to] = dateRange
        return [DateTime.fromISO(from), DateTime.fromISO(to)]
      }
      return []
    },
    convertDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        return dateRange.map((date) => DateTime.fromISO(date).toISO())
      }
      return null
    },
    clearAllData() {
      this.selectedTransactionStatus = undefined
      this.selectedTransactionType = undefined
      this.selectedMorningCoin = undefined
      this.selectedCreatedDateRange = undefined
    },
    getCurrentYear() {
      return DateTime.now().year
    },
    formatDateToTH(date, format) {
      return formatOrFallbackToInput(date, format)
    },
    handleBackToWalletBalanceReportPage() {
      this.$router.replace({ name: "WalletBalanceReportPage" })
    },
    async fetchCoins() {
      this.tableLoading = true

      await backendAdminClient.morningCoin
        .getCoins()
        .then((response) => {
          this.filterMorningCoins = response.data.result
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message
          this.$message.error(
            `ไม่สามารถโหลดรายการ Morning Coin ได้เนื่องจาก "${message || "ไม่พบข้อมูล"}"`,
          )
          // eslint-disable-next-line no-console
          console.error(error)
        })
        .finally(() => {
          this.isAbleButton()
          this.tableLoading = false
        })
    },
    async fetchUserBalanceByUserId(userId) {
      this.tableLoading = true

      await backendAdminClient.morningCoin
        .getUserBalanceByUserId(userId)
        .then((response) => {
          this.walletDetail = response.data.result
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message
          this.$message.error(
            `ไม่สามารถโหลดรายละเอียด wallet ได้เนื่องจาก "${message || "ไม่พบข้อมูล"}"`,
          )
          // eslint-disable-next-line no-console
          console.error(error)
        })
        .finally(() => {
          this.isAbleButton()
          this.tableLoading = false
        })
    },
    async fetchReports() {
      this.tableLoading = true
      const query = this.queryParams

      await backendAdminClient.morningCoin
        .getTransactionsByUserId(this.userId, query)
        .then((response) => {
          const { result } = response.data

          this.reports = result.reports
          this.total = result.total
          this.latest_update_time = result.timestamp ? result.timestamp : null
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message
          this.$message.error(
            `ไม่สามารถโหลดรายการ Transaction History ได้เนื่องจาก "${message || "ไม่พบข้อมูล"}"`,
          )
          // eslint-disable-next-line no-console
          console.error(error)
        })
        .finally(() => {
          this.isAbleButton()
          this.tableLoading = false
        })
    },
    async downloadReportFile(event) {
      // get date format 2024-10-16-14:30:00
      const dateFilename = DateTime.utc()
        .setZone("Asia/Bangkok")
        .toFormat("yyyy-MM-dd-HHmmss")

      // Init file name for download report
      const fileName = `${dateFilename}-transaction-history-reports.xlsx`
      event.preventDefault()
      this.isDisableButton()

      // Send request
      const response =
        await backendAdminClient.morningCoin.downloadReportTransactionsByUserId(
          this.userId,
        )

      // check response before download
      if (response.data) {
        const blob = new Blob([response.data])
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
      }

      this.isAbleButton()
    },
    isDisableButton() {
      this.isDropdownDisabled = true
      this.isSearchDisabled = true
      this.isClearDisabled = true
      this.isClickDownloadAsCSVDisabled = true
      this.isPaginationDisable = true
    },
    isAbleButton() {
      this.isDropdownDisabled = false
      this.isSearchDisabled = false
      this.isClearDisabled = false
      this.isClickDownloadAsCSVDisabled = false
      this.isPaginationDisable = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  z-index: 1;
}

.page-container {
  padding: 30px;
  margin: 0;
}

.router {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.detail {
  width: 100%;
  display: flex;
  margin-top: 2rem;
  flex-direction: column;
}

.detail .section {
  display: flex;
  flex-direction: row;
}

.detail .section p {
  font-size: 16px;
  margin-top: 6px;
}

.detail .section .title {
  color: #777777;
  font-weight: 500;
}

.detail .section .value {
  color: #5f5f5f;
  font-weight: 600;
}

.balance {
  max-width: 600px;
  display: flex;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 24px;
}

.balance .section {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.balance .section .left {
  display: flex;
  flex-direction: column;
  color: #7e7e7e;
  gap: 8px;
}

.balance .section .right {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  font-weight: 600;
  color: #4b4b4b;
  gap: 8px;
}

.balance .vertical-divider {
  width: 1px;
  background-color: #dbdbdb;
  height: auto;
  margin: 0 24px;
  display: inline-block;
}

.filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
  padding: 0;
}

.filter .form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0;
}

.content .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.el-input__inner {
  text-align: center;
}

.el-date-editor--daterange,
.el-input__inner {
  width: 100%;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 1200px) {
  .form .section {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .form .section {
    grid-template-columns: 1fr;
  }

  .balance {
    max-width: 100%;
    flex-direction: column;
    gap: 8px;
  }
}
</style>
